package com.exura.features.demofeatures.di

import org.koin.dsl.module
import com.exura.features.demofeatures.domain.usecase.CheckFeatureEnabledUseCase

val demoFeaturesModule = module {
    factory<CheckFeatureEnabledUseCase> { CheckFeatureEnabledUseCase(get()) }
}
